<script>
    export default {
        name: 'NumberPicker',
        props: {
            numbers: {
                type: Array,
                required: true,
            },
            defaultValue: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            maxHeight: {
                type: String,
                required: true,
            },
            columns: {
                type: Number,
                default: 2,
            },
        },
        data() {
            return {
                selectedNumber: this.defaultValue,
                screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                columnsWidthBreak: 650,
            };
        },
        created() {
            if (this.numbers.length > 0) {
                this.selectFirstAvailableNumber(this.numbers);
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleScreenWidth);
        },
        destroy() {
            window.removeEventListener('resize', this.handleScreenWidth);
        },
        watch: {
            selectedNumber(val) {
                this.$emit('input', val);
            },
            numbers(val) {
                this.selectFirstAvailableNumber(val);
            },
        },
        methods: {
            selectFirstAvailableNumber(numbers) {
                const availableNumbers = numbers.filter(n => n.available);
                if (!('phonenumber' in this.selectedNumber) && availableNumbers.length > 0) {
                    this.selectedNumber = availableNumbers[0];
                    this.$emit('input', this.selectedNumber);
                }
            },
            computeGridColumnFromIndex(index) {
                return index % (this.justifiedColumns) + 1;
            },
            computeGridRowFromIndex(index) {
                return Math.ceil((index + 1) / (this.justifiedColumns));
            },
            handleScreenWidth() {
                this.screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            }
        },
        computed: {
            justifiedColumns() {
                if (this.screenWidth < this.columnsWidthBreak) {
                    return 2;
                }
                return this.columns;
            },
            gridTemplateColumns() {
                    return new Array(this.justifiedColumns + 1).join(' 1fr');
            },
        },
    };
</script>

<template>
    <div class="number-pick">
        <div class="number">
            <h1>{{('phonenumber' in selectedNumber) ? selectedNumber.phonenumber : ''}}</h1>
        </div>
        <div class="number-picker-wrapper" :style="{maxHeight: maxHeight}">
            <div class="number-picker"
                 :style="{gridTemplateColumns: gridTemplateColumns, msGridColumns: gridTemplateColumns}">
                <div class="number-picker-entry" :class="['grid-column-' + computeGridColumnFromIndex(index)]"
                     v-for="(entry, index) in numbers" :key="entry.phonenumberForForm"
                     :style="{msGridRow: computeGridRowFromIndex(index)}">
                    <input :id="'radio_' + entry.id" type="radio" :value="entry" v-model="selectedNumber"
                           :disabled="!entry.available">
                    <label :for="'radio_' + entry.id">...&nbsp;{{entry.phonenumberForForm}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/inputs.scss';
    @import '../../assets/scss/grid.scss';

    .number-pick {
        text-align: left;
        h1 {
            font-size: 18px;
            margin-top: 0;
            margin-bottom: 14px;
            font-weight: 500;
        }

        .number-picker-wrapper {
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 100%;

            &::-webkit-scrollbar {
                width: 8px;
            }

            /* Track */
            &::-webkit-scrollbar-track {
                background: #cccccc;
                border-radius: 3px;
            }

            /* Handle */
            &::-webkit-scrollbar-thumb {
                background: $orange;
                border-radius: 3px;
            }

            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
                background: $orange;
            }
        }

        .number-picker {
            display: grid;
            display: -ms-grid;
            grid-column-gap: 20px;
            grid-row-gap: 10px;
            font-size: 18px;

            .number-picker-entry {
                position: relative;
                label {
                    min-width: 100%;
                    /* min-width: 125px;*/
                }
            }
        }
    }
</style>
